export default __webpack_public_path__ + "static/media/pw-unit-edit-form.276e559d.jpg";